<template>
  <div class="card is-min-width-500">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('produitPresse.encarts.popUpCategorieOperation.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="columns is-multiline">
        <b-field
          :label="$t('produitPresse.encarts.popUpCategorieOperation.categorieOperation')"
          class="column is-12">
          <b-select v-model="categorieOperationSelected" expanded>
            <option :value="null"></option>
            <option
              v-for="categorie in constantes.CATEGORIE_OPERATION"
              :key="categorie.code"
              :value="categorie.code">
              {{ $t(categorie.libelle) }}
            </option>
          </b-select>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <button
              @click="$parent.close()"
              class="button">
              {{ $t('general.button.cancel')}}
            </button>
          </div>
          <div class="is-pulled-left boutonAction">
            <button
              @click="apply()"
              class="button is-addOrEdit">
              {{ $t('general.button.apply') }}
            </button>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import { CATEGORIE_OPERATION } from '@/configuration/catalogue/produitConf';

export default {
  name: 'PopupCategorieOperation',
  data() {
    return {
      categorieOperationSelected: null,
      constantes: {
        CATEGORIE_OPERATION,
      },
    };
  },
  methods: {
    apply() {
      this.$emit('apply', this.categorieOperationSelected);
      this.$parent.close();
    },
  },
};
</script>
